import { render } from "./Grant.vue?vue&type=template&id=9af1d1b8"
import script from "./Grant.vue?vue&type=script&lang=js"
export * from "./Grant.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Special/Grant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9af1d1b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9af1d1b8', __exports__)) {
    api.reload('9af1d1b8', __exports__)
  }
  
  module.hot.accept("./Grant.vue?vue&type=template&id=9af1d1b8", () => {
    api.rerender('9af1d1b8', render)
  })

}


export default __exports__